import { render, staticRenderFns } from "./KSearchBar.vue?vue&type=template&id=560fc49c&scoped=true&"
import script from "./KSearchBar.vue?vue&type=script&lang=js&"
export * from "./KSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./KSearchBar.vue?vue&type=style&index=0&id=560fc49c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560fc49c",
  null
  
)

export default component.exports